import { getUserInfo } from '@/api/user';
import { getComanyList } from '@/api/team/worker';

const app = {
  state: {
    projectList: [],
    menuList: [],
    companyList: [],
  },
  mutations: {
    SET_PORJECT_LIST: (state, projectList) => {
      state.projectList = projectList;
    },
    SET_MENU_LIST: (state, menuList) => {
      state.menuList = menuList;
    },
    SET_COMPANY_LIST: (state, companyList) => {
      state.companyList = companyList;
    },
  },
  actions: {
    setPorjectList({ commit }, projectList) {
      commit('SET_PORJECT_LIST', projectList);
    },
    setMenuList({ commit }, menuList) {
      commit('SET_MENU_LIST', menuList);
    },
    setCompanyList({ commit }, companyList) {
      commit('SET_COMPANY_LIST', companyList);
    },

    // get user info
    doGetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then((response) => {
          if (!response.data) {
            reject(new Error('error'));
          }
          const { data } = response;

          commit('SET_USER', {
            userName: data.userName,
            loginName: data.loginName,
            email: data.email || '',
            mobile: data.mobile || '',
            wechatOpenId: data.wechatOpenId || '',
          });
          // commit('SET_TOKEN', data.token);
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    doGetCompany({ commit, state }) {
      return new Promise((resolve, reject) => {
        getComanyList(state.token).then((response) => {
          if (!response.data) {
            reject(new Error('error'));
          }
          const { data } = response;
          commit('SET_COMPANY_LIST', data);
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
      });
    },

    // clear storage data
    clearStorage({ commit }) {
      return new Promise((resolve) => {
        commit('SET_PORJECT_LIST', []);
        commit('SET_MENU_LIST', []);
        resolve();
      });
    },
  },
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js